// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"
import Message from "./message.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "translated_email_state": {
      "column": null,
      "name": "translated_email_state",
      "selected_by_default": null,
      "translated": null
    },
    "translated_sms_state": {
      "column": null,
      "name": "translated_sms_state",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "MessageRecipient",
  "collectionKey": "message_recipients",
  "collectionName": "message_recipients",
  "i18nKey": "message_recipient",
  "camelizedLower": "messageRecipient",
  "name": "MessageRecipient",
  "nameDasherized": "message-recipient",
  "pluralName": "message_recipients",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Message",
      "collectionName": "messages",
      "foreignKey": "message_id",
      "name": "message",
      "macro": "belongs_to",
      "resource_name": "Message",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "email",
      "column": {
        "default": null,
        "name": "email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "email_state",
      "column": {
        "default": "email_pending",
        "name": "email_state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "in_mobile_no",
      "column": {
        "default": null,
        "name": "in_mobile_no",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "message_id",
      "column": {
        "default": null,
        "name": "message_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_message_id",
      "column": {
        "default": null,
        "name": "old_message_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "phone_number",
      "column": {
        "default": null,
        "name": "phone_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "sms_state",
      "column": {
        "default": "sms_pending",
        "name": "sms_state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Message",
      "collectionName": "messages",
      "foreignKey": "message_id",
      "name": "message",
      "macro": "belongs_to",
      "resource_name": "Message",
      "through": null
    }
  ],
  "paramKey": "message_recipient",
  "primaryKey": "id"
}

/** Frontend model for MessageRecipient. */
export default class MessageRecipient extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedEmailState() {
    return this.readAttributeUnderscore("translated_email_state")
  }

  /** @returns {boolean} */
  hasTranslatedEmailState() {
    const value = this.translatedEmailState()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedSmsState() {
    return this.readAttributeUnderscore("translated_sms_state")
  }

  /** @returns {boolean} */
  hasTranslatedSmsState() {
    const value = this.translatedSmsState()

    return this._isPresent(value)
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./message.js").default | null} */
  message() {
    return this._readBelongsToReflection({modelClass: Message, reflectionName: "message"})
  }

  /** @returns {Promise<import("./message.js").default | null>} */
  loadMessage() {
    if (!("messageId" in this)) throw new Error("Foreign key method wasn't defined: messageId")

    const id = this.messageId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "message",
        model: this,
        modelClass: Message
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./message.js").default | null>} */
  ensureMessageLoaded() {
    return this.ensureAssociationLoaded("message")
  }
}
